import React, { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { UserPlus, X } from "lucide-react";
import { GamemodeDropdown } from "@/components/GamemodeDropdown";

export default function AddProfileDialog({ onAdded }) {
  const [open, setOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [gamemode, setGamemode] = useState("main");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/profiles", { username, gamemode });
      toast.success(`${data.username} added! Prove you own it: gain a little XP, then verify.`);
      setUsername("");
      setOpen(false);
      onAdded(data);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button data-testid="open-add-profile" onClick={() => setOpen(true)} className="osrs-btn px-3 py-2 text-sm flex items-center gap-2">
        <UserPlus size={16} /> Add Account
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4" onClick={() => setOpen(false)}>
          <div className="osrs-panel p-6 w-full max-w-md" onClick={(e) => e.stopPropagation()} data-testid="add-profile-dialog">
            <div className="flex items-center justify-between mb-4">
              <h3 className="osrs-title text-xl">Track an OSRS Account</h3>
              <button onClick={() => setOpen(false)} className="osrs-btn px-2 py-1" data-testid="close-add-profile"><X size={16} /></button>
            </div>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="osrs-shadow text-sm block mb-1">RuneScape Username</label>
                <input
                  data-testid="input-osrs-username"
                  className="osrs-input w-full px-3 py-2"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Lynx Titan"
                  maxLength={12}
                  required
                />
              </div>
              <div>
                <label className="osrs-shadow text-sm block mb-2">Account Type</label>
                <GamemodeDropdown value={gamemode} onChange={setGamemode} />
              </div>
              <button data-testid="submit-add-profile" type="submit" disabled={busy} className="osrs-btn osrs-btn-green w-full py-3">
                {busy ? "Fetching hiscores..." : "Fetch & Track"}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
